import React from 'react';

export const AnalysisSkeleton = () => (
  <div className="animate-pulse space-y-6">
    <div className="flex gap-2">
      {[...Array(5)].map((_, i) => (
        <div key={`skel-${i}`} className="h-10 w-24 bg-slate-200 rounded-lg"></div>
      ))}
    </div>
    <div className="bg-slate-100 rounded-xl h-[400px]"></div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[...Array(3)].map((_, i) => (
        <div key={`skel2-${i}`} className="bg-slate-100 rounded-xl h-48"></div>
      ))}
    </div>
  </div>
);
